import { render, staticRenderFns } from "./reservoir-page.vue?vue&type=template&id=6949c889&scoped=true&"
import script from "./reservoir-page.vue?vue&type=script&lang=js&"
export * from "./reservoir-page.vue?vue&type=script&lang=js&"
import style0 from "./reservoir-page.vue?vue&type=style&index=0&id=6949c889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949c889",
  null
  
)

export default component.exports